import React, { useEffect, useState } from 'react';
import { computeRectangleArea, computeRectangleVolume } from '../helpers/math';
import { getStoredValue, saveToStorage, storeValue } from '../helpers/storage';
import Crust from './Crust';
import { MoldType } from '../helpers/consts-and-types';
import PropTypes from 'prop-types';
import styles from './MoldContainer.module.scss';
import useDebouncedEffect from '../hooks/use-debounced-effect';
import useLocalize from '../hooks/use-localize';
import useMeasureChangeHandler from '../hooks/use-measure-change-handler';

const MoldRectangle = ({ crustVolume, setArea, setCrustArea, setCrustUrl, setCrustVolume, setMoldUrl, setVolume, side }) => {
  const { localize } = useLocalize();
  const [width, setWidth] = useState(() => getStoredValue(side, 'rectangle', 'width', 10));
  const [length, setLength] = useState(() => getStoredValue(side, 'rectangle', 'length', 15));
  const [height, setHeight] = useState(() => getStoredValue(side, 'rectangle', 'height', 4.5));

  useEffect(() => {
    saveToStorage(`${side}-type`, 'rectangle');
  }, []);

  useDebouncedEffect(() => setMoldUrl(`${width}-${length}-${height}`), [height, length, width]);

  useEffect(() => {
    storeValue(side, 'rectangle', [
      ['width', width],
      ['length', length],
      ['height', height],
    ]);
  }, [width, length, height]);

  useEffect(() => {
    setArea(computeRectangleArea(width, length));
  }, [length, setArea, width]);

  useEffect(() => {
    setVolume(computeRectangleVolume(width, length, height));
  }, [height, length, setVolume, width]);

  const handleOnWidthChange = useMeasureChangeHandler(setWidth);
  const handleOnLengthChange = useMeasureChangeHandler(setLength);
  const handleOnHeightChange = useMeasureChangeHandler(setHeight);

  return (
    <div className={styles.grid}>
      <div>{localize('mold.width')}</div>
      <div className={styles.measure}>{width}&nbsp;cm</div>
      <input max='50' min='1' onChange={handleOnWidthChange} step='.5' type='range' value={width} />
      <div>{localize('mold.length')}</div>
      <div className={styles.measure}>{length}&nbsp;cm</div>
      <input max='50' min='1' onChange={handleOnLengthChange} step='.5' type='range' value={length} />
      <div>{localize('mold.height')}</div>
      <div className={styles.measure}>{height}&nbsp;cm</div>
      <input max='10' min='1' onChange={handleOnHeightChange} step='.5' type='range' value={height} />
      <Crust height={height} length={length} moldType={MoldType.Rectangle} setArea={setCrustArea} setCrustUrl={setCrustUrl} setVolume={setCrustVolume} side={side} volume={crustVolume} width={width} />
    </div>
  );
};

MoldRectangle.propTypes = {
  crustVolume: PropTypes.number.isRequired,
  setArea: PropTypes.func.isRequired,
  setCrustArea: PropTypes.func.isRequired,
  setCrustUrl: PropTypes.func.isRequired,
  setCrustVolume: PropTypes.func.isRequired,
  setMoldUrl: PropTypes.func.isRequired,
  setVolume: PropTypes.func.isRequired,
  side: PropTypes.string.isRequired,
};

export default MoldRectangle;
